<!--
  找商机-展商端-编辑 
-->
<template>
  <div class="menu-item-r">
    <div class="find-oppirtunity-view">
      <findOpportunity-edit v-if="action === 'list'"></findOpportunity-edit>
      <release-opportunity  v-if="action === 'publish'"></release-opportunity>
  </div>
  </div>
</template>
<script>

import findOpportunityEdit from './findOpportunityEdit.vue'
import releaseOpportunity from './releaseOpportunity.vue'
export default {

  components: {
    findOpportunityEdit,
    releaseOpportunity
  },
  data() {
    return {
      action: this.$route.params.action
    }
  },
  computed: {
   
  },
  mounted() {
   
  },
  methods: {
   
  }
}
</script>

<style lang="stylus" scoped>
.find-oppirtunity-view {
  background-color : $color-white;
}
.op-pagination {
  text-align : right;
  margin-top : 60px;
  width : 612px;
  padding-bottom : 60px;
}
</style>
